/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Nursing Education View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './NursingEducationView';

export const mapStateToPropsNursingEducation = mapStateToProps;
export const mapDispatchToPropsNursingEducation = mapDispatchToProps;

export default connect(
  mapStateToPropsNursingEducation,
  mapDispatchToPropsNursingEducation
)(View);
